import { Modal } from '@/ui/Modal';

type JourneyJoinModalProps = {
  open: boolean;
  onJoin: () => void;
  onClose: () => void;
  loading: boolean;
};

export const JourneyJoinModal = ({ open, onClose, onJoin, loading }: JourneyJoinModalProps): JSX.Element | null => {
  return (
    <Modal open={open} onClose={onClose} size="mobile">
      <Modal.Title>Join this journey</Modal.Title>
      <Modal.Contents>
        This item is part of a learning journey.
        <br />
        <br />
        Join now to unlock your progress, stay on track, and get the full experience.
      </Modal.Contents>

      <Modal.Actions>
        <Modal.Action action={onClose}>Not now</Modal.Action>
        <Modal.Action loading={loading} disabled={loading} primary action={onJoin}>
          Join
        </Modal.Action>
      </Modal.Actions>
    </Modal>
  );
};
